import { h } from '../pragma.mjs';
import { settings } from '../../config/settingsFactory.mjs';
import { getValidSetting } from '../../utils/common.mjs';

export default (isPublic) => {

    return (
        <div> 

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#" class="no-focus-change">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Zápisy</strong></li>
                </ul>
            </gov-breadcrumbs>

            <gov-tiles>
                <gov-tile href={isPublic ? getValidSetting(settings.urls?.NV?.public,'#','NV link public') : getValidSetting(settings.urls?.NV?.private,'#','NV link private')} target="_blank" id="rozcestnikZiskalTile">
                    <p>Chci požádat o změnu vlastnického práva, zápis nebo výmaz věcného břemene, zástavního práva, předkupního práva, práva stavby atd.</p>
                    <h3 slot="title">Změna práva vkladem&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="institute-file" slot="icon"></gov-icon>
                </gov-tile>

                <gov-tile href="#" id="rozcestnikZapsatTile">
                    <p>Chci zapsat nebo vymazat poznámku (žalobu, dovolání, exekuci, předběžné opatření ...), upozornění atd.</p>
                    <h3 slot="title">Změna dalších údajů o právech, poznámkách a upozorněních</h3>
                    <gov-icon type="complex" name="population-register" slot="icon"></gov-icon>
                </gov-tile>

                <gov-tile href="#" id="rozcestnikPostavilTile">
                    <p>Chci požádat o zápis nové stavby, změnu typu stavby, čísla domovního, způsobu využití nebo zrušení zápisu stavby atd.</p>
                    <h3 slot="title">Změna údajů o stavbách</h3>
                    <gov-icon type="complex" name="property" slot="icon"></gov-icon>
                </gov-tile>

                <gov-tile href="#" id="rozcestnikZmenitTile">
                    <p>Chci požádat o zápis změny druhu pozemku, způsobu využití, zpřesnění hranice pozemku, rozdělení nebo sloučení parcel, změnit způsob využití jednotky, atd.</p>
                    <h3 slot="title">Změna údajů o pozemcích</h3>
                    <gov-icon type="complex" name="map" slot="icon"></gov-icon>
                </gov-tile>

                <gov-tile href="#" id="rozcestnikDalsiTile">
                    <p>Chci požádat o zápis jednotek , uložení úplného prohlášení o vymezení jednotek, změnit údaje o značce podrobného polohového bodového pole atd.</p>
                    <h3 slot="title">Další ...</h3>
                    <gov-icon type="complex" name="all" slot="icon"></gov-icon>
                </gov-tile>
            </gov-tiles>
        </div>
    )
}